//interfaces
import { CombinedFeedSortType, feedSourceStatus, IFeedSources } from  "@/interfaces/CombinedFeed";
import { DropdownGroupInfo } from  "@/interfaces/orgSettings";


export function getEnumFromSortTypeString(sortTypeString?: string){
    switch (sortTypeString) {
        case 'DateCreatedNewest':
            return CombinedFeedSortType.DateCreatedNewest
        case 'DateCreatedOldest':
            return CombinedFeedSortType.DateCreatedOldest;
        case 'DateModifiedNewest':
            return CombinedFeedSortType.DateModifiedNewest;
        case 'DateModifiedOldest':
            return CombinedFeedSortType.DateModifiedOldest;
        case 'AlphabeticalAZ':
            return CombinedFeedSortType.TitleAZ;
        case 'AlphabeticalZA':
            return CombinedFeedSortType.TitleZA;
        default:
            return CombinedFeedSortType.DateCreatedNewest;
    }
}

export function getSortTypeFromEnum(sortType: any){
    switch (sortType) {
            case CombinedFeedSortType.DateCreatedNewest:
                return 'DateCreatedNewest'
            case CombinedFeedSortType.DateCreatedOldest:
                return 'DateCreatedOldest';
            case CombinedFeedSortType.DateModifiedNewest:
                return 'DateModifiedNewest';
            case CombinedFeedSortType.DateModifiedOldest:
                return 'DateModifiedOldest';
            case CombinedFeedSortType.TitleAZ:
                return 'AlphabeticalAZ';
            case CombinedFeedSortType.TitleZA:
                return 'AlphabeticalZA';
            default:
                return 'DateCreatedNewest'
        }
}

export function getSourceListTooltipSettings (tooltipData: DropdownGroupInfo[], maxShownLists = 3) {
    const extraCount = tooltipData.length - maxShownLists;

    const extraDetailText =
        extraCount > 0
        ? `${extraCount} more ${extraCount > 1 ? "lists" : "list"}`
        : undefined;

    const visibleItems = Math.min(tooltipData.length, maxShownLists);

    const tooltipHeight =
        28 + visibleItems * 28 + (tooltipData.length > maxShownLists ? 28 : 0);

    const marginBottom = tooltipHeight + 38;

    return {
        marginBottom,
        extraDetailText,
    };
}

export function extractFullFeedSources(feedSources: IFeedSources[]): DropdownGroupInfo[] {
    const checkingIds = new Set<number>();

    return feedSources.flatMap(({ parents }) =>
        parents.flatMap(parent => {
            if (parent.contentFeedSourceListStatus !== feedSourceStatus.full) return [];
            if (checkingIds.has(parent.id)) return [];

            checkingIds.add(parent.id);

            return [{
                title: parent.title,
                subtitle: "",
                displayIcon: false,
                icon: undefined,
            }];
        })
    );
}